import { GroupLabel } from "components/front/mypage/layout/GroupLabel";
import { CourseServiceType, MessageThread } from "interfaces/front/business";
import React, { FC, useMemo } from "react";
import { ListContainer } from "../layout/list/ListContainer";
import MessageThreadItem from "./MessageThreadItem";

const MessageThreadListArea: FC<{
  messageThreads: MessageThread[];
  onSelectItem: (messageThread: MessageThread) => void;
  activated: boolean;
}> = ({ messageThreads, onSelectItem, activated }) =>
  messageThreads.length > 0 ? (
    <ListContainer className={activated ? "activated" : ""}>
      <GroupedMessageThreadListArea
        messageThreads={messageThreads}
        onSelectItem={onSelectItem}
        label="クラウドファンディング"
        serviceType="crowd_funding"
      />
      <GroupedMessageThreadListArea
        messageThreads={messageThreads}
        onSelectItem={onSelectItem}
        label="ふるさと納税"
        serviceType="hometown_tax"
      />
      <GroupedMessageThreadListArea
        messageThreads={messageThreads}
        onSelectItem={onSelectItem}
        label="企業版ふるさと納税"
        serviceType="corp_hometown_tax"
      />
      <GroupedMessageThreadListArea
        messageThreads={messageThreads}
        onSelectItem={onSelectItem}
        label="アニメショッピング"
        serviceType="shopping"
        isShopping={true}
      />
    </ListContainer>
  ) : (
    <div style={{ marginBottom: "600px" }}>メッセージはありません。</div>
  );
export default MessageThreadListArea;

const GroupedMessageThreadListArea: FC<{
  messageThreads: MessageThread[];
  serviceType: CourseServiceType;
  label: string;
  isShopping?: boolean;
  onSelectItem: (messageThread: MessageThread) => void;
}> = ({ messageThreads, serviceType, label, isShopping, onSelectItem }) => {
  const groupedMessageThreads = useMemo(() => messageThreads.filter((it) => it.service_type === serviceType), [messageThreads]);
  if (groupedMessageThreads.length === 0) return <></>;
  return (
    <div style={{ marginBottom: "30px" }}>
      <GroupLabel style={{ marginBottom: "10px" }}>{label}</GroupLabel>
      {groupedMessageThreads.map((messageThread, index) => (
        <MessageThreadItem key={index} messageThread={messageThread} isShopping={isShopping} onSelectItem={(): void => onSelectItem(messageThread)} />
      ))}
    </div>
  );
};
